requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('product-recommendations')) {
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
          this.cachedResponses = {};
        }

extractProductRecommendations(html) {
  const start = html.indexOf('<product-recommendations');

  if (start === -1) return '';

  const openingTagEnd = html.indexOf('>', start);
  const end = html.indexOf('</product-recommendations>', openingTagEnd);

  if (openingTagEnd === -1 || end === -1) return '';

  return html
    .slice(openingTagEnd + 1, end)
    .trim();
}
        buildRecommendationsUrl() {
          const url = new URL(this.dataset.url, window.location.origin);

          if (this.dataset.productId && !url.searchParams.has('product_id')) {
            url.searchParams.set('product_id', this.dataset.productId);
          }

          if (this.dataset.sectionId && !url.searchParams.has('section_id')) {
            url.searchParams.set('section_id', this.dataset.sectionId);
          }

          if (this.dataset.intent && !url.searchParams.has('intent')) {
            url.searchParams.set('intent', this.dataset.intent);
          }

          return url.toString();
        }

        fetchRecommendations(url) {
          if (this.cachedResponses[url]) {
            return Promise.resolve(this.cachedResponses[url]);
          }

          return fetch(url)
            .then((response) => response.text())
            .then((text) => {
              this.cachedResponses[url] = text;
              return text;
            });
        }

        removeEmptySection() {
          const wrapper = this.dataset.wrapperId ? document.getElementById(this.dataset.wrapperId) : null;

          if (wrapper) {
            wrapper.remove();
          } else {
            this.remove();
          }
        }

        afterLoad() {
          if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
            this.remove();
            return;
          }

          if (this.querySelector('.slider__slide')) {
            this.classList.add('product-recommendations--loaded');
          } else if (this.dataset.hideEmpty === 'true') {
            this.removeEmptySection();
            return;
          }

          scriptController.executeWhenScriptLoaded('slider-component.js', () => {
            const slider = this.querySelector('slider-component');

            if (slider && typeof slider.resetPages === 'function') {
              slider.resetPages();
            }
          });

          window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
          window.lazyImages.find();
        }

        connectedCallback() {
          const designMode = typeof Shopify !== 'undefined' && Shopify.designMode;

          if (this.dataset.recommendationsPerformed === 'true') return;
          if (!this.dataset.url) return;
          if (!this.dataset.productId && !this.dataset.url.includes('product_id=')) {
            if (this.dataset.hideEmpty === 'true' && !designMode) this.removeEmptySection();
            return;
          }

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            const url = this.buildRecommendationsUrl();

            this.fetchRecommendations(url)
              .then((text) => {
                const recommendationsHTML = this.extractProductRecommendations(text);

                if (recommendationsHTML.length) {
                  this.innerHTML = typeof lazyTemplateController !== 'undefined' ?
                    lazyTemplateController.cleanHTMLWithTemplate(recommendationsHTML) :
                    recommendationsHTML;
                  this.dataset.recommendationsPerformed = 'true';
                }

                this.afterLoad();
              })
              .catch((e) => {
                console.error(e);
              });
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '1000px 0px 1000px 0px'
          }).observe(this);
        }
      }

      customElements.define('product-recommendations', ProductRecommendations);
    }
  });
});